import { render, staticRenderFns } from "./CommunityMenu.vue?vue&type=template&id=d317cc68&scoped=true&"
import script from "./CommunityMenu.vue?vue&type=script&lang=js&"
export * from "./CommunityMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d317cc68",
  null
  
)

export default component.exports